import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translateService = inject(TranslateService);

  currentLang = signal<string>('uz');

  private static readonly SUPPORTED = ['uz', 'uz-cyrl', 'ru', 'en'];

  /** Called once by APP_INITIALIZER — loads the saved (or browser) language before first render. */
  async init(): Promise<void> {
    this.translateService.addLangs(LanguageService.SUPPORTED);
    this.translateService.setDefaultLang('uz');

    const savedLang = localStorage.getItem('appLang');

    const lang = savedLang && LanguageService.SUPPORTED.includes(savedLang) ? savedLang : 'uz';

    this.currentLang.set(lang);
    await firstValueFrom(this.translateService.use(lang));
  }

  switchLanguage(lang: string) {
    if (LanguageService.SUPPORTED.includes(lang)) {
      this.translateService.use(lang);
      this.currentLang.set(lang);
      localStorage.setItem('appLang', lang);
    }
  }

  getCurrentLang(): string {
    return this.currentLang();
  }
}
